export default __webpack_public_path__ + "static/media/logo_agap2IND.07343fdc.svg";